// removed by extract-text-webpack-plugin
module.exports = {"section-header":"_1G17z6om","sectionHeader":"_1G17z6om","left":"_1Tv8akcR","right":"_3tU4WRJX","img":"_3o7NE5jh"};


//////////////////
// WEBPACK FOOTER
// ./src/components/SectionHeader/SectionHeader.pcss
// module id = 383
// module chunks = 0